import React from 'react';
import CarSimulationOption from './CarSimulationOption.js';
import { Button } from 'react-bootstrap';

require(`../assets/${process.env.PAGE}/css/components/CarSimulationOfferGroups.css`);

class CarSimulationOfferGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedOffer: null,
            expandedBrand: null,
        };
    }

    toggleExpand() {
        this.setState((prevState) => ({
            expandedOffer: !prevState.expandedOffer,
        }));
    }

    handleBrandClick(brand) {
        this.setState((prevState) => {
            if (prevState.expandedBrand === brand) {
                return { expandedBrand: null };
            } else {
                return { expandedBrand: brand };
            }
        }, () => {
            if (this.state.expandedBrand === brand && this.buttonRefs && this.buttonRefs[brand]) {
                const buttonPosition = this.buttonRefs[brand].getBoundingClientRect();
                window.scrollTo(0, buttonPosition.top + window.pageYOffset - 80);
            }
        });
    }

    formatOfferName(offerName) {
        const stringWithSpaces = offerName.replace(/_/g, ' ');
        const capitalizedString = stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1);
        return capitalizedString;
    }

    setButtonRef(brand, element) {
        this.buttonRefs = this.buttonRefs || {};
        this.buttonRefs[brand] = element;
    }

    renderBrand(brand, formattedOfferName) {
        const { expandedBrand } = this.state;
        const { offers, selectProductOption } = this.props;

        return (
            <div key={brand}>
                <div ref={(element) => this.setButtonRef(brand, element)}>
                <Button className="btn-brand" onClick={() => this.handleBrandClick(brand)}>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 brand-container align-center">
                        <img alt="Logo" src={require(`../assets/${process.env.PAGE}/img/carBrands/${brand}.png`)} />
                    </div>
                </Button>
                </div>
                {expandedBrand === brand &&
                    offers
                        .filter((offer) => offer.marca === brand)
                        .map((car, index) => (
                            <CarSimulationOption
                                key={index}
                                selectProductOption={selectProductOption}
                                formattedOfferName={formattedOfferName}
                                disabled={false}
                                car={car}
                                expanded={false}
                            >
                            </CarSimulationOption>
                        ))
                }
            </div>
        );
    }

    render() {
        const { offerName, offers } = this.props;
        const { expandedOffer } = this.state;

        const formattedOfferName = this.formatOfferName(offerName);

        const brands = [...new Set(offers.map((offer) => offer.marca))];

        return (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 offer-options">
                    <div className="offer-group">
                        <Button className="btn-offer" onClick={() => this.toggleExpand()}>
                            <h2>{formattedOfferName}</h2>
                        </Button>
                        {expandedOffer &&
                            (brands.map((brand) => this.renderBrand(brand, formattedOfferName)))}
                    </div>
                </div>
            </div>
        );
    }
}

export default CarSimulationOfferGroup;


/** WEBPACK FOOTER **
 ** ./src/components/CarsimulationOfferGroup.js
 **/